export default __webpack_public_path__ + "static/media/logo_1.7beca8bc.png";